import { ImportVehiclesCtx } from "../ImportVehiclesContext";
import { useContext } from "react";

const useImportVehiclesContext = () => {
    const ctx = useContext(ImportVehiclesCtx);

    if (!ctx) {
        throw new Error("ImportVehiclesCtx is not setup");
    }
    return ctx;
};

export default useImportVehiclesContext;
